<template>
    <input v-bind:type="type" v-bind:value="label" v-on="$listeners" class="btn m-r-5 m-b-5" />
</template>

<script>
export default {
    props: [
        'label',
        'type'
    ]
}
</script>